import styled from 'styled-components';

import { TextButton as BreweryTextButton } from '@xing-com/button';
import { xdlColorTextInvert, xdlColorText } from '@xing-com/tokens';

export const List = styled.ol`
  padding: 0;
`;

export const ListItem = styled.li`
  display: inline-block;
  list-style: none;
`;

export const TextButton = styled(BreweryTextButton)<{ $active: boolean }>`
  text-transform: uppercase;
  justify-content: center;
  border-radius: ${({ $active }) => ($active ? '50%' : 'none')};
  background-color: ${({ $active }) =>
    $active ? xdlColorText : 'transparent'};
  color: ${({ $active }) => ($active ? xdlColorTextInvert : xdlColorText)};
`;
